function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#47dfed;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M10.817,0A10.817,10.817,0,1,0,21.633,10.817,10.829,10.829,0,0,0,10.817,0ZM16.3,8.524,10.44,14.383a.9.9,0,0,1-1.275,0L6.236,11.454A.9.9,0,1,1,7.51,10.179L9.8,12.472,15.024,7.25A.9.9,0,0,1,16.3,8.524Zm0,0"
});

var SvgComprobar = function SvgComprobar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.633,
    height: 21.633,
    viewBox: "0 0 21.633 21.633",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComprobar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comprobar.f3715bf2.svg";
export { ForwardRef as ReactComponent };